import {
  InteractionRequiredAuthError,
  PublicClientApplication,
} from "@azure/msal-browser";

export const config = {
  backendEndpoint: "https://cbbapi-st.shi-ev.com/api/office/",
  defaultEndpoint: "https://cbbapi-st.shi-ev.com/api/office/",
  clientEndpoint: "https://cbb-st.shi-ev.com/",
  clientId: "a36c5be5-e8af-4a35-a4f8-4c0eeeb7b906",
  tenantId: "963d0cb9-c29b-4266-82ba-950d434afb6e",
  allowedDomains: "shi-g.com",
  timeoutDefault: 36000000,
};

export const msalConfig = {
  auth: {
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenantId}`,
    redirectUri: config.clientEndpoint,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
};

let msalInstance = new PublicClientApplication(msalConfig);

export const getAllowedDomains = () => {
  return config.allowedDomains.split(",");
};

export const getLoginRequest = () => {
  return {
    scopes: [`${config.clientId}/.default`],
  };
};

export const getMsalInstance = () => {
  return msalInstance;
};

export const getToken = async () => {
  const msalInstance = getMsalInstance();
  const accounts = msalInstance.getAllAccounts();

  const loginRequest = getLoginRequest();

  if (accounts.length === 0) {
    await msalInstance.loginRedirect(loginRequest);
    return null;
  }

  const request = {
    ...loginRequest,
    account: accounts[0],
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
    } else {
      throw error;
    }
  }
};

export const logOut = () => {
  const msalInstance = getMsalInstance();
  const account =
    msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  localStorage.removeItem("msalConfig");

  // Helpful hints so the IdP ends the right session:
  msalInstance.logoutRedirect({
    account,
    logoutHint: account ? account.username : undefined, // helps Entra pick the right session
    postLogoutRedirectUri: "/", // your public landing
  });
};

export const toyotaKamoId = 35001;
export const arrayClInputDate = [1122, 1956];
export const yuniId = 10019;
export const workingSaveStatus = [2, 3];
